import React from 'react'
import Header from './Header'
import Footer from './Footer'
import SocialSidebar from './SocialSidebar'
import WhatsAppButton from './WhatsAppButton'

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <SocialSidebar />
      <WhatsAppButton />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default Layout